export const conversationColumns = [
  ["id", "شناسه", "string"], ["chatId", "شناسه گفتگو", "string"],
  ["userId", "شناسه کاربر", "string"], ["message", "پیام", "string"],
  ["createdAt", "تاریخ", "date"], ["seen", "دیده شده", "bool"],
].map(([name, title, type]) => ({ name, title, type, showInList: true, colSpan: 1 }));

/** Current GetAll returns PascalCase rows, null header and no total count. */
export function conversationTableResponse(payload, { page, limit }) {
  const data = (payload.data || []).map((row) => ({ ...row,
    ...Object.fromEntries(Object.entries(row).map(([key, value]) => [key[0].toLowerCase() + key.slice(1), value])),
  }));
  return { ...payload, data, header: Array.isArray(payload.header) ? payload.header : conversationColumns,
    // A full page permits probing the next page; do not invent a total record count.
    meta: payload.meta || { total_pages: data.length === limit ? page + 1 : page },
  };
}
